/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const PolicySkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={200} className={classes.shortSk} />
          <Skeleton count={1} width={270} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={770} className={classes.longSk} />
          <Skeleton count={1} width={770} className={classes.longSk} />
          <Skeleton count={1} width={770} className={classes.longSk} />
        </div>
      </div>
      <div className={classes.secondPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={200} className={classes.shortSk} />
          <Skeleton count={1} width={270} className={classes.shortSk} />
        </div>
        <div>
          <Skeleton count={1} width={770} className={classes.longSk} />
          <Skeleton count={1} width={770} className={classes.longSk} />
          <Skeleton count={1} width={770} className={classes.longSk} />
        </div>
      </div>
    </div>
  );
};

export default PolicySkeleton;
